import { useState, useEffect } from "react";
import Styleclasses from "../Basic-info/style.module.css";
import UploadDc from "./Doc.module.css";
import { Get_Documents, Add_Documents, UpdateStatus } from "Services/Requests";
import Upload from "Assets/upload.png";
import Load from "Components/Loader/loader";
import { useForm, SubmitHandler } from "react-hook-form";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { config } from "s3config";
import ReactS3Client from "react-aws-s3-typescript";
import { FaDownload } from "react-icons/fa";
import Moment from "react-moment";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";

type Inputs = {
    document_comment: string;
    sub_status: string;
};

const Fileupload = () => {
    return (
        <div className={Styleclasses["File-upload"]}>
            <img src={Upload} alt="upload" />
            <p>Upload File</p>
        </div>
    );
};

function PersonalInfo() {
    const fileTypes = ["JPG", "PNG", "GIF"];
    const navigate = useNavigate();
    const [Documents, setDocuments] = useState([]);
    const [isCommented, setIsCommented] = useState(0);
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: { sub_status: "corrections_required" },
    });
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await Get_Documents("previous_year");

            if (response.data.Status == 1) {
                setLoading(false);
                setDocuments(response?.data?.Documents);
                // setIsCommented(response?.data?.is_comment_updated);
                setValue("document_comment", response?.data?.document_comment);
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team1"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };


    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        console.log(data);
        setLoading(true);
        try {
            const response = await UpdateStatus({
                ...data,
                is_comment_updated:
                    data?.sub_status == "corrections_required" ? 0 : 1,
            });
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Updaate Success");
                // setIsCommented("");

                GetDetails();
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    return (
        <div className={Styleclasses["Container"]}>
            {loading && <Load />}

            <div className={UploadDc["table"]}>
                <h3>Documents</h3>
                <table>
                    <thead>
                        <th>S No</th>
                        <th>Document Name</th>
                        <th>Document Type</th>
                        <th>Comments</th>
                        <th>Uploaded on</th>
                        <th>Actions</th>
                    </thead>
                    <tbody>
                        {Documents.length > 0 ? (
                            Documents.map((item: any, index: any) => (
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{item.file_name}</td>
                                    <td>{item.file_type}</td>
                                    <td>{item.comments}</td>
                                    <td>
                                        <Moment format="DD-MM-YY">
                                            {item.createdAt}
                                        </Moment>
                                    </td>
                                    <td
                                        onClick={() =>
                                            window.open(
                                                item.download_id,
                                                "_blank"
                                            )
                                        }>
                                        {" "}
                                        <FaDownload color="#2db2bc" />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} style={{ textAlign: "center" }}>
                                    No Documents found{" "}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default PersonalInfo;
